/**
 * Copyright (c) 2024, Ouster, Inc.
 * All rights reserved.
 */
import {
  action,
  thunk,
  Action as EzPzAction,
  Thunk as EzPzThunk,
} from 'easy-peasy';

export type State = {
  isOpen: boolean;
  isLoading: boolean;
  isPublic: boolean;
  isShared: boolean;
  onConfirm: () => Promise<void>;
};

export const defaultState: State = {
  isOpen: false,
  isLoading: false,
  isPublic: false,
  isShared: false,
  onConfirm: async () => {},
};

export interface ConfirmDialogModel extends State {
  openConfirmDialog: EzPzThunk<
    ConfirmDialogModel,
    { isPublic: boolean; isShared?: boolean; onConfirm: () => Promise<void> }
  >;
  closeConfirmDialog: EzPzAction<ConfirmDialogModel>;
  setIsOpen: EzPzAction<ConfirmDialogModel, boolean>;
  setIsLoading: EzPzAction<ConfirmDialogModel, boolean>;
  setIsPublic: EzPzAction<ConfirmDialogModel, boolean>;
  setIsShared: EzPzAction<ConfirmDialogModel, boolean>;
  setOnConfirm: EzPzAction<ConfirmDialogModel, () => Promise<void>>;
}

export const modal: ConfirmDialogModel = {
  ...defaultState,
  openConfirmDialog: thunk((actions, payload) => {
    actions.setOnConfirm(payload.onConfirm);
    actions.setIsPublic(payload.isPublic);
    actions.setIsShared(payload.isShared || false);
    actions.setIsOpen(true);
  }),
  closeConfirmDialog: action((state) => {
    state.isOpen = false;
    state.isLoading = false;
  }),
  setIsOpen: action((state, isOpen) => {
    state.isOpen = isOpen;
  }),
  setIsShared: action((state, isShared) => {
    state.isShared = isShared;
  }),
  setIsPublic: action((state, isPublic) => {
    state.isPublic = isPublic;
  }),
  setIsLoading: action((state, isLoading) => {
    state.isLoading = isLoading;
  }),
  setOnConfirm: action((state, onConfirm) => {
    state.onConfirm = onConfirm;
  }),
};
